import {makeActionCreators} from '../../core-utilities/redux';

/**
 * @param {Object} options
 * @return {TodoMessageActions}
 */
export function buildActions({prefix}) {
  return makeActionCreators(prefix, [{
    name: 'selectAction',
    type: 'SELECT_ACTION',
  }, {
    name: 'updateI18n',
    type: 'UPDATE_I18N',
  }]);
}

/**
 * TODO: finish defining this. Should probably define ActivityFeed item as well
 * @typedef {Object} TodoMessage
 * @property {String} id
 * @property {String} collection
 * @property {String} type
 * @property {String} msg
 * @property {DomainLink} target
 * @property feedable TODO: figure out if/how this needs to apply to the todo message system
 * @property feedTarget TODO: figure out if/how this needs to apply to the todo message system
 * @property {Object} data
 * @property {String} selectedAction The ID of the selected action
 * @property {Object<String, TodoMessageAction>} actions
 * @property {SyncStatus} syncStatus
 */

/**
 * TODO: finish defining this
 * @typedef {Object} TodoMessageAction
 * @property {String} id
 * @property {String} type
 * @property {String} msg
 * @property {String} selectedMsg
 *
 * // need to cover label and probably a message code to display if the action is selected
 *
 */

/**
 * @typedef {Object} SelectActionPayload
 * @property {String} id
 * @property {String} actionId
 */

/**
 * @typedef {ReduxObservableListActions} TodoMessageActions
 * @property {Function|ReduxActionCreator<SelectActionPayload>} selectAction
 * @property {Function|ReduxActionCreator<Void>} updateI18n
 */



// WEBPACK FOOTER //
// ./src/js/todo-messages/redux/todoMessageActions.js